module.exports = __webpack_public_path__ + "img/billing-code-h.5d33c7fe.svg";